// eslint-disable-next-line import/prefer-default-export
export const TOKEN_STORAGE_KEY = 'crdf_adata';
